export const GET_SITE_SEARCH_REQUEST='siteSearchReducer/GET_SITE_SEARCH_REQUEST';
export const GET_SITE_SEARCH_SUCCESS='siteSearchReducer/GET_SITE_SEARCH_SUCCESS';
export const GET_SITE_SEARCH_FAILED='siteSearchReducer/GET_SITE_SEARCH_FAILED';
